import { useDispatch, useSelector } from 'react-redux';
import { Text, LinkComponent } from '@rsos/components/capstone/base';
import onSAMLrequest from '@rsos/utils/onSAMLrequest';

const SUPPORT_SERVICE = 'support';

export const CommunicationDescription = ({ persistor }) => {
  const dispatch = useDispatch();

  const { sinatra } = useSelector(state => state);
  const isLoadingSAML = sinatra.auth.loadingSAML;
  const handleSupportRequest = () => {
    return onSAMLrequest(SUPPORT_SERVICE, dispatch, isLoadingSAML, persistor);
  };
  return (
    <Text size="normal" color="secondaryText" mb={2}>
      Below are Text-from 911 conversations from the past 30 days. All
      conversations are available to download as a csv file. Please reach out to
      <LinkComponent onClick={handleSupportRequest}>support</LinkComponent>if
      you have any questions.
    </Text>
  );
};
